export default __webpack_public_path__ + "static/media/shift-type.b955dff3.svg";